<template>
    <div class="min-h-full flex flex-col gap-1">
        <div class="flex justify-start items-center gap-1 w-full">
            <div class="w-2 h-2 rounded-full bg-[#FE5000]"></div>
            <div class="w-9 h-2 rounded-full bg-[#FE5000]"></div>
            <p class="text-xl font-bold pl-2 m-0 text-[#092E87]">Cash</p>
        </div>
        <div class="w-full py-2">
            <p class="text-lg m-0 font-normal leading-[20px] text-[#333333]">Please pay the amount <span
                    class="font-bold text-xl">${{
                                $helper.formatAmount(invoiceDetail?.amount?? '0')}}</span> in cash to the fyxify <span class="font-bold text-xl">PRO</span> to proceed
                further</p>
        </div>
    </div>
</template>
<script>
export default {
    props:['invoiceDetail']
}
</script>